import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary';
  isExternal?: boolean;
}
export function Button({
  children,
  href,
  onClick,
  className = '',
  variant = 'primary',
  isExternal = false
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-bold rounded-full transition-all duration-300 transform shadow-lg hover:shadow-xl text-center w-full sm:w-auto';
  const variants = {
    primary: 'bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white shadow-cyan-500/25',
    secondary: 'bg-lime-500 hover:bg-lime-400 text-slate-900 shadow-lime-500/25'
  };
  const Component = motion.button;
  const motionProps = {
    whileHover: {
      scale: 1.02
    },
    whileTap: {
      scale: 0.98
    }
  };
  if (href) {
    if (isExternal) {
      return <motion.a href={href} className={`${baseStyles} ${variants[variant]} ${className}`} {...motionProps as any} data-id="element-57">
          {children}
        </motion.a>;
    }
    return <motion.a href={href} onClick={e => {
      if (href.startsWith('#')) {
        e.preventDefault();
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
      if (onClick) onClick();
    }} className={`${baseStyles} ${variants[variant]} ${className}`} {...motionProps as any} data-id="element-58">
        {children}
      </motion.a>;
  }
  return <Component onClick={onClick} className={`${baseStyles} ${variants[variant]} ${className}`} {...motionProps} data-id="element-59">
      {children}
    </Component>;
}